import {useTranslation} from 'react-i18next'
import {EntitySearchSelect} from '@/components/entity-search-select'
import {Tag} from '@/components/ui/tag'
import type {Employee} from '@/hooks/empresa/identidad/use-employees'

/** `roster` mixes nómina and externos con acceso (`useResponsablesRoster`). */
export function EmpleadoSelect({
  roster,
  value,
  placeholder,
  testId,
  disabled,
  onPick,
}: {
  roster: Employee[]
  value: string | null
  placeholder: string
  testId: string
  disabled?: boolean
  onPick: (id: string | null) => void
}) {
  const {t} = useTranslation()
  return (
    <EntitySearchSelect
      items={roster}
      value={roster.find((p) => p.id === value) ?? null}
      getKey={(p) => p.id}
      filterText={(p) => `${p.name} ${p.last_name}`}
      renderOption={(p) => (
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="min-w-0 truncate">
            {p.name} {p.last_name}
          </span>
          {p.vinculo === 'externo' && <Tag tone="neutral">{t('plan.externoTag')}</Tag>}
        </span>
      )}
      renderTriggerValue={(p) => (
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="min-w-0 truncate">
            {p.name} {p.last_name}
          </span>
          {p.vinculo === 'externo' && <Tag tone="neutral">{t('plan.externoTag')}</Tag>}
        </span>
      )}
      placeholder={placeholder}
      searchPlaceholder={t('planTrabajo.detalle.buscarPlaceholder')}
      noResultsLabel={t('planTrabajo.detalle.sinResultados')}
      clearLabel={placeholder}
      testId={testId}
      disabled={disabled}
      onPick={(p) => onPick(p?.id ?? null)}
    />
  )
}
